import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './styles/index.css'

console.log('Main.tsx loaded, environment:', import.meta.env.MODE)

// Optional service worker (disabled by default to avoid cache issues on Netlify)
// If disabled, proactively unregister any existing SW and clear caches so users get fresh bundles
if ('serviceWorker' in navigator) {
  if (import.meta.env.VITE_ENABLE_SW === 'true') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js?version=' + Date.now())
        .then((registration) => {
          console.log('SW registered: ', registration)
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError)
        })
    })
  } else {
    // Unregister any existing SW and clear caches
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister())
    })
    if ('caches' in window) {
      caches.keys().then(keys => keys.forEach(key => caches.delete(key)))
    }
  }
}

try {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  )
} catch (error) {
  console.error('Failed to render React app:', error)
  // Fallback rendering
  const root = document.getElementById('root')
  if (root) {
    root.innerHTML = `
      <div style="padding: 20px; text-align: center; font-family: Arial, sans-serif;">
        <h1>Loading Error</h1>
        <p>There was an error loading the application. Please refresh the page.</p>
        <p>Error: ${error instanceof Error ? error.message : 'Unknown error'}</p>
      </div>
    `
  }
}
